import { FaBrain } from "react-icons/fa";
import CustomButton from "../../ui/CustomButton";
import { useState } from "react";
import useServiceStatus from "../../hooks/useServiceStatus";
import { FaLock } from "react-icons/fa6";
import RequestLiveSuggestionModal from "../../shared/ai-trade-suggestion/RequestLiveSuggestionModal";

function LiveAiButton({
  exchange = "",
  coin = "",
  className = "",
  style = {},
  title,
  iconColor,
  icon,
  iconPosition = "end",
}) {
  const [showLiveModal, setShowLiveModal] = useState(false);

  const { isActive: isAiActive } = useServiceStatus("aiAssistant");
  const { isActive: isInsightActive } = useServiceStatus("insight");
  const isActive = isInsightActive || isAiActive;

  return (
    <>
      <CustomButton
        type="primary"
        disabled={!isActive}
        onClick={() => {
          setShowLiveModal(true);
        }}
        className={className}
        style={style}
      >
        {iconPosition === "start" ? (
          !isActive ? (
            <FaLock />
          ) : (
            icon || <FaBrain color={iconColor || ""} />
          )
        ) : (
          ""
        )}
        {title || "Pivot"}
        {iconPosition === "end" ? (
          !isActive ? (
            <FaLock />
          ) : (
            icon || <FaBrain color={iconColor || ""} />
          )
        ) : (
          ""
        )}
      </CustomButton>

      {showLiveModal && (
        <RequestLiveSuggestionModal
          show={showLiveModal}
          setShow={setShowLiveModal}
          exchange={exchange}
          coin={coin?.split("/USDT")?.[0]}
        />
      )}
    </>
  );
}

export default LiveAiButton;
